export default __webpack_public_path__ + "media/get-verified-liveness.f27e1ba589d42d24089782e4b5b3e9ee.png";